import {Filters} from 'src/modules/attributes/typedefs';
import {RootState} from 'src/store/store';

export const getAttributesFilters = (state: RootState): Filters => state.attributesFilters.data;
